// ═══════════════════════════════════════
// HISTORY — Undo/Redo custom pour contenteditable
// ═══════════════════════════════════════

import {
    highlightAll, restoreCursor,
    parseAbcDocument, setHeadersContent,
    setVoiceHeaderContent, setVoiceContent, getVoiceCount
} from './editor.js';
import { render } from './renderer.js';

const MAX_HISTORY = 100;
const DEBOUNCE_MS = 500;

let _stack   = [];
let _ptr     = -1;
let _timer   = null;
let _blocked = false;

export function historyReset(text) {
    clearTimeout(_timer);
    _stack   = [{ text: text ?? '', cursor: 0 }];
    _ptr     = 0;
    _blocked = false;
}

export function historySchedulePush(text, cursor) {
    if (_blocked) return;
    clearTimeout(_timer);
    _timer = setTimeout(() => _push(text, cursor), DEBOUNCE_MS);
}

export function historyPushNow(text, cursor) {
    if (_blocked) return;
    clearTimeout(_timer);
    _push(text, cursor);
}

export function historyUndo() {
    if (_ptr <= 0) return false;
    clearTimeout(_timer);
    _ptr--;
    _restore(_stack[_ptr]);
    return true;
}

export function historyRedo() {
    if (_ptr >= _stack.length - 1) return false;
    clearTimeout(_timer);
    _ptr++;
    _restore(_stack[_ptr]);
    return true;
}

export function historyIsBlocked() { return _blocked; }

function _push(text, cursor) {
    if (_ptr >= 0 && _stack[_ptr].text === text) return;
    _stack = _stack.slice(0, _ptr + 1);
    _stack.push({ text, cursor });
    if (_stack.length > MAX_HISTORY) _stack.shift();
    _ptr = _stack.length - 1;
}

function _restore(entry) {
    _blocked = true;

    const { global, voiceHeaders, voices } = parseAbcDocument(entry.text);
    setHeadersContent(global);
    voiceHeaders.forEach((h, i) => setVoiceHeaderContent(i, h));
    voices.forEach((v, i) => setVoiceContent(i, v));

    // Restaurer le curseur sur la voix active (voix 0 par défaut)
    const activeEl = document.getElementById('abc-voice-0');
    if (activeEl) restoreCursor(activeEl, entry.cursor);

    highlightAll();
    render();
    setTimeout(() => { _blocked = false; }, 0);
}